import clsx from 'clsx';

import { ActivityCard } from '../log-coordination/ActivityCard';
import { StudentActivityListItem } from './singleStudent.types';
import { groupActivitiesByMonth } from './StudentActivities.utils';

type StudentActivitiesListProps = {
  activities: StudentActivityListItem[];
};

export const StudentActivitiesList = ({ activities }: StudentActivitiesListProps) => {
  return (
    <div className="space-y-8">
      {groupActivitiesByMonth(activities).map(({ month, activities: monthActivities }, index) => (
        <div key={month}>
          <h3
            className={clsx('text-body-lg-desktop text-neutral-200', index === 0 ? 'mb-6' : 'mb-3')}
          >
            {month}
          </h3>
          <div className="space-y-3">
            {monthActivities.map((activity) => (
              <ActivityCard key={activity.id} activity={activity} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
